import { graphql } from '@prophecy/graphql-types/graphql';
export const SetUserPreferenceQuery = graphql(`
  mutation setUserPreference($userPreference: String!) {
    setUserPreference(userPreference: $userPreference)
  }
`);
export const GetUserPreferenceQuery = graphql(`
  query getUserPreference($key: String) {
    getUserPreference(key: $key)
  }
`);
export const SetProjectUserPreferenceQuery = graphql(`
  mutation setProjectUserPreference($projectUID: String!, $userPreference: String!) {
    setProjectUserPreference(projectUID: $projectUID, userPreference: $userPreference)
  }
`);
export const GetProjectUserPreferenceQuery = graphql(`
  query getProjectUserPreference($projectUID: String!, $key: String) {
    getProjectUserPreference(projectUID: $projectUID, key: $key)
  }
`);
